import type { Path } from "@/types/path";

type SuggestionRankPath = Pick<
  Path,
  "id" | "title" | "path_root_id" | "path_type" | "version" | "is_published" | "metadata"
>;

export function parseSuggestionRank(metadata: unknown): number | null {
  const r = (metadata as Record<string, unknown> | null)?.suggestion_importance_rank;
  return typeof r === "number" && Number.isFinite(r) ? r : null;
}

function getRootId(path: Pick<SuggestionRankPath, "id" | "path_root_id">): string {
  return path.path_root_id || path.id;
}

function getDisplayPathForRank(paths: SuggestionRankPath[]): SuggestionRankPath {
  const sorted = [...paths].sort((a, b) => b.version - a.version);
  return sorted.find((p) => !p.is_published) || sorted.find((p) => p.is_published) || sorted[0];
}

export function findSuggestionRankConflict(
  paths: SuggestionRankPath[],
  rank: number | null,
  currentPathId?: string,
): SuggestionRankPath | null {
  if (rank === null) return null;

  const currentPath = currentPathId ? paths.find((p) => p.id === currentPathId) : null;
  const currentRootId = currentPath ? getRootId(currentPath) : null;
  const byRoot = new Map<string, SuggestionRankPath[]>();

  for (const path of paths) {
    if (path.path_type !== "path") continue;
    const rootId = getRootId(path);
    if (rootId === currentRootId) continue;
    byRoot.set(rootId, [...(byRoot.get(rootId) || []), path]);
  }

  for (const rootPaths of byRoot.values()) {
    const displayPath = getDisplayPathForRank(rootPaths);
    if (parseSuggestionRank(displayPath.metadata) === rank) return displayPath;
  }

  return null;
}
